import React, { Component } from 'react';
import PropType from 'prop-types';

import ListView from '../Common/ListView.react';
import ListItem from './LocationListItem';
import VenueIcon from 'material-ui/svg-icons/communication/location-on';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';

import LocationActions from '../../actions/LocationActionCreator';
import LocationStore from '../../stores/LocationStore';

import buildContextMenu from '../Common/BuildContextMenu';

const getActions = () => [
    {
        link: '/dashboard/venues',
        icon: <VenueIcon />,
        label: 'Venues',
    },
    { type: 'divider' },
    {
        link: '/logout',
        icon: <CancelIcon />,
        label: 'Sign out',
    },
];

class LocationList extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            locations: LocationStore.getAll(),
            count: 0,
            page: 0,
            limit: 50,
            actions: [],
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.locationListener = LocationStore.addListener(this.onChange);
        LocationActions.getAll();
        this.setState({actions: buildContextMenu(getActions(), this.context.auth)});
    }

    componentWillUnmount() {
        this.locationListener.remove();
    }

    render() {

        return (
            <ListView
                title="Locations"
                sortOptions={this.props.sortOptions}
                sortAction={LocationActions.getAll}
                searchAction={LocationActions.search}
                actions={this.state.actions}
                items={this.state.locations}
                itemDecorator={ListItem}
            />
        )
    }

    onChange() {
        this.setState({locations: LocationStore.getAll()});
    }
}

LocationList.contextTypes = {
    auth: PropType.object.isRequired
};

LocationList.defaultProps = {
    sortOptions: [
        {label: "Name", value: 'name'},
        {label: "Capacity", value: 'capacity'},
        {label: "Status", value: 'statusId'},
    ]
};

export default LocationList;
